import { render, staticRenderFns } from "./StoragesView.vue?vue&type=template&id=61739cbc&lang=true"
import script from "./StoragesView.vue?vue&type=script&lang=js"
export * from "./StoragesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports